<template>
  <div id="app">

    <div class="operation-tool">
      <div @click="addCard()" class="tool-item"> <img src="../../../static/img/btn/add.png" />添加分类</div>
    </div>

    <div class="l-panel">
     <div class="panel-body">

        <el-table class="l-table" :data="tableData" style="width: 100%" >
          <el-table-column prop="name" label="分类名称" align="left"></el-table-column>
          <el-table-column prop="addtime" label="更新时间" align="left"></el-table-column>
          <el-table-column prop="status" label="是否指定接收人" align="left">
            <template slot-scope='{row}'>
                <span>{{row.status == 1 ? '否' :'是'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="receiver" label="消息接收人" align="left"></el-table-column>
          <el-table-column prop="status" label="操作" align="right">
            <template slot-scope='{row}'>
                  <el-button type="primary" @click='dialogFix(row)' size="mini">修改</el-button>
                  <el-button type="danger" @click='deleteCar(row)' size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="c-table-pager">
          <el-pagination  :total="total" @current-change='paginationChange'> </el-pagination>
        </div>

     </div>
    </div>


    <el-dialog :title="selectRow.id ?'编辑车费参考价' : '添加车费参考价'" :visible.sync="dialogVisible" class='dialogClass' width="1000px">
      <div class="dialogContent">
        <el-form :model="selectRow" ref="selectRow" label-width="100px" class="demo-ruleForm" :rules="rules">
          <el-form-item label="异常分类名" prop="name">
              <el-input v-model="selectRow.name" placeholder="请输入异常分类名称"></el-input>
          </el-form-item>
          <el-form-item label="id" prop="id" v-if='idInput'>
              <el-input v-model="selectRow.id" placeholder="请输入id"></el-input>
          </el-form-item>
          <el-form-item label="指定接收人"  prop="status">
              <el-radio v-model="selectRow.status" label="1" border>否</el-radio>
              <el-radio v-model="selectRow.status" label="2" border>是</el-radio>
          </el-form-item>
          <el-form-item label="接收人">
              <el-checkbox-group v-model="receiver_id">
                  <el-checkbox  v-for='(item,index) in receiverList' :key='index' :label="item.id" :name='item.id'>{{item.oausername}}</el-checkbox>
              </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('selectRow')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        info: {
          page: 1,
          key:'',
          begintimes:[],
          begintime:'',
          endtime:'',
          key_type:''

        },
        total: 1,
        tableData:[],
        dialogVisible:false,
        basic:{
            distance:'',
            money:'',
        },
        rules:{
           name: [ { required: true, message: '请输入异常分类名称', trigger: 'blur' },],
           id: [ { required: true, message: '请输入id', trigger: 'blur' },],
           status: [ { required: true, message: '请选择是否指定接收人', trigger: 'change' },],
        },
        receiverList:[],
        selectRow:{
          receiver_id:[]
        },
        receiver_id:[],
        idInput:false

      }
    },

    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=true");
          });
    },

    mounted() {
      this.queryInfo()
      this.getReceiver()
    },
    methods: {

      deleteCar(row){
        this.$confirm('此操作将删除此条数据, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                 this.post('setting/unusualNewsTypeDelete',{id:row.id}).then((res)=>{
                   this.queryInfo()
                   res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
                 })
                }).catch(() => {});
      },

      dialogFix(row){
        this.receiver_id = row.receiver_id
        for(let i in row){
          row[i] = row[i]+''
        }
        this.selectRow = row;
        this.dialogVisible = true
        this.idInput = false
      },

      getReceiver(){
        this.gets('oasystem/cateadminlist').then(res=>{
          let data = res.data.data
          data.map((item)=>{return item.id = item.id + ''})
          this.receiverList = data
        })
      },

        submitForm(formName) {
              this.$refs[formName].validate((valid) => {
                if (valid) {
                  let {id,status} = this.selectRow;
                  if(status == 2){
                    if(!this.receiver_id.length){
                      return Message.warning('请选择接收人')
                    }else{
                      this.selectRow.receiver_id = this.receiver_id
                    }
                  }else{
                    this.selectRow.receiver_id = []
                  }
                  let url = !this.idInput ? 'setting/unusualNewsTypeEdit' : 'setting/unusualNewsTypeAdd'
                    this.post(url,this.selectRow).then(res=>{
                      Message[res.data.code == 1?'success':'warning'](res.data.msg)
                      this.dialogVisible = res.data.code == 1? false :true;
                      this.queryInfo()
                    })
                } else {
                 return console.log('error submit!!');
                }
              });
            },

      addCard(){
        for(let i in this.selectRow){
          this.selectRow[i] = ''
        }
        this.receiver_id = []
        this.dialogVisible = true
        this.idInput = true
      },

      paginationChange(val) {
        this.info.page = val
        this.queryInfo()
      },

      queryInfo() {
        this.gets('setting/unusualNewsTypeList', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        })
      }
    }
  }
</script>

<style scoped>
  .table {
    margin: 30px 0;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
  }

  .pagination {
    text-align: center;
    width: 100%;
    background: #fff;
    height: 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pagination >>> .button{
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .dialogClass >>> .el-dialog{
    max-width: 1000%;
  }
</style>



// WEBPACK FOOTER //
// src/view/system/unusualNewsTypeList.vue